import React, { createContext, useContext } from 'react';

export interface LiteShellContextValue {
  /** When true, SRP uses minimal shell and defers full filter/sidebar UI until interaction */
  isLiteShell: boolean;
  /** True after idle or user interaction – real header/sidebar can replace skeletons */
  fullShellLoaded?: boolean;
  /** Call when user requests full UI (e.g. clicks "Filters" or "Search") */
  requestFullShell?: () => void;
}

const defaultValue: LiteShellContextValue = {
  isLiteShell: false,
};

const LiteShellContext = createContext<LiteShellContextValue>(defaultValue);

export function LiteShellProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: LiteShellContextValue;
}) {
  return (
    <LiteShellContext.Provider value={value}>
      {children}
    </LiteShellContext.Provider>
  );
}

export function useLiteShell(): LiteShellContextValue {
  return useContext(LiteShellContext);
}
